export default __webpack_public_path__ + "static/media/layer-custom.ac4087fb.svg";